// Third-party Imports
import { createSlice } from '@reduxjs/toolkit'

export const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    contacts: [],
    chats: [],
    activeUser: null,
    profileUser: null
  },
  reducers: {
    getActiveUserData: () => {

    },

    addNewChat: (action) => {


    },

    setUserStatus: () => {

    },

    sendMsg: () => {

    }
  }
})

export const { getActiveUserData, addNewChat, setUserStatus, sendMsg } = chatSlice.actions

export default chatSlice.reducer
